export const useURL = (slug?: string) => {
    //const url = `https://tusitioweb.dev/osania/wp-json/wp/v2`;
    const url = `https://osania.com/admin/index.php/wp-json/wp/v2`;
    if(slug) return `${url}${slug}`;
    return `${url}`
}